import { toast } from '../ui';

interface SavedQuoteResultPanelProps {
  url: string;
  onDismiss: () => void;
}

export default function SavedQuoteResultPanel({ url, onDismiss }: SavedQuoteResultPanelProps) {
  return (
    <div className="mt-4 bg-green-500/10 border border-green-500/30 rounded-lg p-4 flex flex-col gap-3">
      <div className="flex items-center gap-2">
        <span className="material-symbols-outlined text-green-400">check_circle</span>
        <span className="text-green-200 font-bold text-sm">Quotation Generated Successfully</span>
      </div>
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="bg-white text-secondary font-bold text-sm px-4 py-3 rounded-lg hover:bg-white/90 transition-colors flex items-center justify-center gap-2 shadow-sm"
      >
        <span className="material-symbols-outlined text-[18px]">open_in_new</span>
        Open Quotation Preview
      </a>
      <button
        onClick={() => {
          void navigator.clipboard.writeText(url);
          toast.success('Link copied to clipboard.');
        }}
        className="bg-white/10 text-white/80 font-bold text-xs px-3 py-2 rounded-lg hover:bg-white/20 transition-colors flex items-center justify-center gap-2 border border-white/20 uppercase tracking-wider"
      >
        <span className="material-symbols-outlined text-[14px]">content_copy</span>
        Copy Link
      </button>
      <a
        href={url + '?send=1'}
        target="_blank"
        rel="noopener noreferrer"
        className="bg-blue-600 text-white font-bold text-sm px-4 py-3 rounded-lg hover:bg-blue-500 transition-colors flex items-center justify-center gap-2 shadow-sm"
      >
        <span className="material-symbols-outlined text-[18px]">send</span>
        Send to Customer
      </a>
      <p className="text-[10px] text-white/40 font-mono break-all select-all leading-relaxed">
        {url}
      </p>
      <button
        onClick={onDismiss}
        className="text-[10px] text-white/40 hover:text-white/70 uppercase tracking-widest font-bold mt-1 self-end"
      >
        Dismiss
      </button>
    </div>
  );
}
